import useRoomBaseServer from '@/domain/room/roombase.server.js';
import { isPc, merge, randomNumGenerator } from '@/utils/index.js';
import BaseServer from './base.server';
import VhallPaasSDK from '@/sdk/index.js';
import useGroupServer from '../group/StandardGroupServer';
import useMediaCheckServer from '../media/mediaCheck.server';
import { getPlatform } from '@/utils/http';
class MsgServer extends BaseServer {
  constructor() {
    if (typeof MsgServer.instance === 'object') {
      return MsgServer.instance;
    }
    super();
    this.msgInstance = null; //主房间消息实例
    this.groupMsgInstance = null; //子房间消息实例
    this.curMsgInstance = null; //当前所在的房间实例
    this.state = {
      msgSdkInitOptions: {},
      groupMsgSdkInitOptions: {}
    };
    this.EVENT_TYPE = {
      CHANNEL_CHANGE: 'CHANNEL_CHANGE'
    };
    this.listenEvents();
    MsgServer.instance = this;
    return this;
  }

  _eventhandlers = {
    ROOM_MSG: [], // 房间消息
    CHAT: [], // 聊天消息
    CUSTOM_MSG: [], // 自定义消息
    OFFLINE: [], // 断开连接
    ONLINE: [], // 连接成功
    JOIN: [], // 加入房间
    LEFT: [] // 离开房间
  };

  // 回放状态下，观看端只能收到以下类型的房间消息
  _roomMsgWhiteListInPlayback = [
    'gift_send_success', // 礼物赠送成功消息
    'reward_pay_ok', // 打赏成功消息
    'base_num_update', // 虚拟人数消息
    'question_answer_create', // 创建问答
    'question_answer_commit', // 回复问答
    'question_answer_backout', // 撤回问答
    'pay_success', // 支付成功
    'qa_like'//问答同问
  ]

  listenEvents() {
    this.$onMsg('ROOM_MSG', msg => {
      const { join_info } = useRoomBaseServer().state.watchInitData
      // 结束直播或在小组中结束直播，需要销毁socket，并且只有观众会销毁
      if (
        join_info.role_name == 2 &&
        (msg.data.type == 'live_over' ||
          (msg.data.type == 'group_switch_end' && msg.data.over_type))
      ) {
        window.bonreeJsBridge?.setCustomLog('[MsgServer] live_over destroy call');
        this.destroy(true);
        this.destroyGroupMsg(true);
      }

      switch (msg.data.type) {
        // 踢出房间消息，销毁socket
        case 'room_kickout':
          if (msg.data.target_id == join_info.third_party_user_id) {
            window.bonreeJsBridge?.setCustomLog('[MsgServer] room_kickout destroy call');
            this.destroy(false);
            this.destroyGroupMsg(false);
          }
          break;
        //结束直播
        case 'live_over':
          this.$emit('live_over', msg)
          break;
        case 'live_start':
          this.$emit('live_start', msg)
          break;
      }
    });
  }
  async init() {
    try {
      await this.initMaintMsg();
      const { groupInitData } = useGroupServer().state;
      if (groupInitData.isInGroup) {
        await this.initGroupMsg();
      }
    } catch (ex) {
      this.$emit('msg_init_failed', ex)
      window.bonreeJsBridge?.setCustomLog('[MsgServer] initMaintMsg error:', ex?.message);
      if (ex instanceof Error) {
        throw ex
      } else {
        throw new Error(ex);
      }
    }
  }
  // 初始化主房间聊天sdk
  async initMaintMsg(customOptions = {}) {
    const defaultOptions = this.getDefaultOptions();
    useRoomBaseServer().state.ssoKick.kickMark = defaultOptions.context.kick_mark;
    const options = merge.recursive({}, defaultOptions, customOptions);
    console.log('聊天初始化参数', options);
    this.state.msgSdkInitOptions = options;
    window.VhallPaasSDK = VhallPaasSDK
    const vhallchat = await VhallPaasSDK.modules.VhallChat.createInstance(options);
    this.msgInstance = vhallchat.message;
    console.log(`[MsgServer] initMaintMsg success: channelId=${options.channelId}`);
    window.bonreeJsBridge?.setCustomLog('[MsgServer] initMaintMsg success.', `channelId=${options.channelId}`);
    this.changeChannel(this.msgInstance);
    this._addListeners(this.msgInstance);
  }
  async initGroupMsg(customOptions = {}) {
    //如果已存在子房间先销毁
    const defautlGroupOptions = this.getGroupDefaultOptions();
    useRoomBaseServer().state.ssoKick.kickMark = defautlGroupOptions.context.kick_mark;
    const options = merge.recursive({}, defautlGroupOptions, customOptions);
    this.state.groupMsgSdkInitOptions = options;
    //创建pass消息房间实例
    const vhallchat = await VhallPaasSDK.modules.VhallChat.createInstance(options);
    this.groupMsgInstance = vhallchat.message;
    this.changeChannel(this.groupMsgInstance);
    this._addListeners(this.groupMsgInstance);
  }
  // 初始化快问快答-app-sdk聊天长连接
  async initAppSdkMaintMsg(customOptions = {}) {
    const defaultOptions = {}
    // {
    //   context: defaultContext,
    //   appId: watchInitData.interact.paas_app_id,
    //   accountId: watchInitData.join_info.third_party_user_id,
    //   channelId: watchInitData.interact.channel_id,
    //   token: watchInitData.interact.paas_access_token,
    //   hide: false // 是否隐身
    // };
    const options = merge.recursive({}, defaultOptions, customOptions);
    console.log('聊天app-sdk初始化参数', options);
    this.state.msgSdkInitOptions = options;
    window.VhallPaasSDK = VhallPaasSDK
    const vhallchat = await VhallPaasSDK.modules.VhallChat.createInstance(options);
    this.msgInstance = vhallchat.message;
    console.log('聊天app-sdk主房间消息实例', this.msgInstance);
    this.changeChannel(this.msgInstance);
    this._addListeners(this.msgInstance);
  }

  changeChannel(istance) {
    this.curMsgInstance = istance;
    //对外通知切换房间
    this.$emit(this.EVENT_TYPE.CHANNEL_CHANGE);
  }
  // 注册事件
  $onMsg(eventType, fn) {
    if (this._eventhandlers[eventType]) {
      this._eventhandlers[eventType].push(fn);
    } else {
      this._eventhandlers[eventType] = [];
      this._eventhandlers[eventType].push(fn);
    }
  }

  _handlePaasInstanceOn(instance, eventType, fn) {
    const cb = msg => {
      if (!msg) {
        return;
      }
      // 房间消息统一parse
      try {
        if (msg && typeof msg === 'string') {
          msg = JSON.parse(msg);
        }
        if (msg && msg.context && typeof msg.context === 'string') {
          msg.context = JSON.parse(msg.context);
        }
        if (msg && msg.data && typeof msg.data === 'string') {
          msg.data = JSON.parse(msg.data);
        }
      } catch (ex) {
        console.log('消息转换错误：', ex);
        return;
      }
      console.log('msg消息', eventType, msg.data.type, msg);
      //判断房间id 该消息属于当前所在房间才处理回调
      if (this.curMsgInstance.channelId == msg.channel) {
        if (msg.data?.type === 'push_goods_change') {
          const push_status = msg.data.push_status == 1 ? '推送' : (msg.data.push_status == 2 ? '取消推送' : msg.data.push_status)
          window.bonreeJsBridge?.setCustomLog(`message:${msg.data.type}:  ${JSON.stringify({ push_status })}`);
        } else if (msg.data?.type === 'goods_update_info') {
          window.bonreeJsBridge?.setCustomLog(`message:${msg.data.type}`);
        }
        try {
          fn(msg);
        } catch (e) {
          console.error('_handlePaasInstanceOn:', e)
        }
      }
    };
    // 'room';
    // 'custom'
    switch (eventType) {
      //房间消息
      case 'ROOM_MSG':
        instance.onRoomMsg(cb); // 这个小写的字符串是跟微吼云沟通添加的，现在房间消息还没有常量
        break;
      //聊天消息
      case 'CHAT':
        instance.on(cb);
        break;
      case 'JOIN':
        instance.join(cb);
        break;
      case 'JOIN_ANY':
        // instance.on(VhallChat.EVENTS.JOIN_ANY, fn);
        break;
      case 'LEFT':
        instance.leave(cb);
        break;
      case 'LEFT_ANY':
        // instance.on(VhallChat.EVENTS.LEFT_ANY, fn);
        break;
      case 'KICK':
        // instance.on(VhallChat.EVENTS.KICK, fn);
        break;
      //自定义消息
      case 'CUSTOM_MSG':
        instance.onCustomMsg(cb)
        break;
      // case 'MUTE':
      //   instance.on(VhallChat.EVENTS.MUTE, fn);
      //   break;
      // case 'UNMUTE':
      //   instance.on(VhallChat.EVENTS.UNMUTE, fn);
      //   break;
      // case 'SUPER_ALLOW':
      //   instance.on(VhallChat.EVENTS.SUPER_ALLOW, fn);
      //   break;
      // case 'UNSUPER_ALLOW':
      //   instance.on(VhallChat.EVENTS.UNSUPER_ALLOW, fn);
      //   break;
      // case 'MUTE_ALL':
      //   instance.on(VhallChat.EVENTS.MUTE_ALL, fn);
      //   break;
      // case 'UNMUTE_ALL':
      //   instance.on(VhallChat.EVENTS.UNMUTE_ALL, fn);
      //   break;
      case 'OFFLINE':
        instance.onOffLine(cb);
        break;
      case 'ONLINE':
        instance.onOnLine(cb);
        break;

      default:
        instance.onCustomMsg(cb);
    }
  }

  // 注销事件
  $offMsg(eventType, fn) {
    if (!this._eventhandlers[eventType]) {
      return new Error('该消息未注册');
    }

    if (!fn) {
      this._eventhandlers[eventType] = [];
      // this._handlePaasInstanceOff(eventType);
      return;
    }

    const index = this._eventhandlers[eventType].indexOf(fn);
    if (index > -1) {
      this._eventhandlers[eventType].splice(index, 1);
      // this._handlePaasInstanceOff(eventType, fn);
    }
  }

  // paas实例注销事件
  // _handlePaasInstanceOff(eventType, fn) {
  //   if (this.groupMsgInstance) {
  //     this.groupMsgInstance.off(eventType, fn);
  //   } else {
  //     this.msgInstance.off(eventType, fn);
  //   }
  // }

  // 为聊天实例注册事件
  _addListeners(instance) {
    for (let eventType in this._eventhandlers) {
      this._handlePaasInstanceOn(instance, eventType, msg => {
        // 回放状态，房间消息白名单
        const { watchInitData } = useRoomBaseServer().state
        const platform = getPlatform()
        if (
          eventType == 'ROOM_MSG' &&
          watchInitData?.join_info?.role_name == 2 &&
          watchInitData?.webinar?.type == 5 &&
          platform != 18 &&
          this._roomMsgWhiteListInPlayback.indexOf(msg.data.type) == -1 &&
          'record_watch_expire_set' !== msg?.data?.type && // 不拦截 回放有效期消息
          'red_packet_end' !== msg?.data?.type && // 不拦截 红包消息
          'red_packet_received' !== msg?.data?.type
        ) {
          return;
        }

        if (msg.data.type == 'live_start' &&
          watchInitData?.join_info?.role_name == 2 &&
          watchInitData?.webinar?.type == 5 &&
          platform == 18) {
          msg.data.type = 'sdk_live_start'
        }

        // 为了兼容老客户端，开始彩排的时候，嘉宾会收到开始直播和结束直播的消息。网页不需要关心直接 return 即可
        if (
          (watchInitData?.join_info?.role_name == 4) &&
          msg.data.live_type == 2 &&
          (msg.data.type == 'live_start' || msg.data.type == 'live_over')
        ) {
          return;
        }

        // 彩排地址的观众，如果活动状态不是直播中，只处理开始彩排的消息，其他消息不处理。
        if (
          watchInitData?.join_info?.role_name == 2 &&
          watchInitData?.live_type == 2 &&
          watchInitData?.webinar?.type != 1 &&
          msg.data.type != 'live_start_rehearsal'
        ) {
          return
        }

        // 如果是主办方端，收到开始彩排直接转成开始直播
        // 如果是观众端并且是彩排地址，收到的开始彩排直接转成开始直播
        if (
          (msg.data.type == 'live_start_rehearsal' || msg.data.type == 'live_over_rehearsal') &&
          ((watchInitData?.join_info?.role_name == 2 && watchInitData?.live_type == 2) ||
            [1, 3, 4, 20].includes(watchInitData?.join_info?.role_name))
        ) {
          msg.data.type = msg.data.type == 'live_start_rehearsal' ? 'live_start' : 'live_over';
        }

        if (this._eventhandlers[eventType].length) {
          this._eventhandlers[eventType].forEach(handler => {
            if (msg.data.type == 'live_over' && !['send', 'record', 'clientEmbed'].includes(useRoomBaseServer().state.clientType)) {
              // 20250208直播活动结束后，持续播放观看端收看完整内容处理：http://wiki.vhallops.com/pages/viewpage.action?pageId=372408541
              // 收到live_over消息后，如果有视频延迟，则进行延迟处理
              setTimeout(() => {
                handler(msg);
              }, (useRoomBaseServer().state.playDelay + 3) * 1000)
            } else {
              handler(msg);
            }
          });
        }
      });
    }

    // Tim消息监听
    if (instance?.msg) {
      instance.msg.on('onTimKickedOut', this._onTimKickedOut.bind(this))
      instance.msg.on('onTimNetStateChange', this._onTimNetStateChange.bind(this))
    }
  }

  // 为聊天实例注销事件
  _removeListeners(instance) {
    for (let eventType in this._eventhandlers) {
      instance.off(eventType);
    }
    // Tim消息监听
    if (instance?.msg) {
      instance.msg.off('onTimKickedOut', this._onTimKickedOut.bind(this))
      instance.msg.off('onTimNetStateChange', this._onTimNetStateChange.bind(this))
    }
  }

  // 发送聊天消息
  sendChatMsg(data, context) {
    this.curMsgInstance.emit(data, context);
  }

  // 发送当前房间消息
  sendRoomMsg(data) {
    this.curMsgInstance.emitRoomMsg(data);
  }
  //发送主房间消息
  sendMainRoomMsg(data) {
    this.msgInstance.emitRoomMsg(data);
  }
  //发送自定义消息
  sendCustomMsg(data) {
    this.curMsgInstance.emitCustomMsg(data);
  }
  // 获取主房间聊天sdk初始化默认参数
  // TODO:根据中台实际需要，更改context
  getDefaultOptions() {
    const { state: roomBaseServerState } = useRoomBaseServer();
    const isPcClient = isPc();
    const { watchInitData, interactToolStatus = {} } = roomBaseServerState;
    const { groupInitData } = useGroupServer().state;
    const defaultContext = {
      nickname: watchInitData.join_info.nickname,
      avatar: watchInitData.join_info.avatar,
      pv: watchInitData.pv && (watchInitData.pv.num2 ?? watchInitData.pv.real), // pv
      uv: watchInitData.online && (watchInitData.online.num || watchInitData.online.virtual),
      role_name: watchInitData.join_info.role_name,
      device_type: this.isMobileDevice() ? 1 : 2, // 设备类型 1手机端 2PC 0未检测
      device_status: useMediaCheckServer().state.deviceInfo.device_status == 2 ? 2 : 1, // 设备状态  0未检测 1可以上麦 2不可以上麦
      audience: roomBaseServerState.clientType !== 'send',
      kick_id: roomBaseServerState.ssoKick?.kickId || sessionStorage.getItem('kickId') || '', // 如果为null传空字符串是为了解决ios客户端崩溃的问题。客户端升级6.4.0版本之后，该字段将无须前端再做兼容
      kick_mark: `${randomNumGenerator()}${watchInitData.webinar.id}`,
      is_banned: interactToolStatus.is_banned,
      privacies: watchInitData.join_info.privacies || '',
      groupInitData//只代表刚进入直播时小组状态，不代表实时小组状态
    };

    const defaultOptions = {
      context: defaultContext,
      appId: watchInitData.interact.paas_app_id,
      accountId: watchInitData.join_info.third_party_user_id,
      channelId: watchInitData.interact.channel_id,
      token: watchInitData.interact.paas_access_token,
      hide: false // 是否隐身
    };

    return defaultOptions;
  }
  // 获取子房间聊天sdk初始化默认参数
  // TODO:根据中台实际需要，调整context
  getGroupDefaultOptions() {
    const { state: roomBaseServerState } = useRoomBaseServer();
    const isPcClient = isPc();
    const { watchInitData, interactToolStatus = {} } = roomBaseServerState;
    const { groupInitData } = useGroupServer().state;
    const defaultContext = {
      nickname: watchInitData.join_info.nickname,
      avatar: watchInitData.join_info.avatar,
      pv: watchInitData.pv.num2 || watchInitData.pv.real, // pv
      uv: watchInitData.online.num || watchInitData.online.virtual,
      role_name: watchInitData.join_info.role_name,
      device_type: this.isMobileDevice() ? 1 : 2, // 设备类型 1手机端 2PC 0未检测
      device_status: useMediaCheckServer().state.deviceInfo.device_status == 2 ? 2 : 1, // 设备状态  0未检测 1可以上麦 2不可以上麦
      watch_type: isPcClient ? '1' : '2', // 1 pc  2 h5  3 app  4 是客户端
      audience: roomBaseServerState.clientType !== 'send', //是不是观众
      kick_mark: `${randomNumGenerator()}${watchInitData.webinar.id}`,
      privacies: watchInitData.join_info.privacies || '',
      groupInitData: groupInitData,
      is_banned: groupInitData.isInGroup ? groupInitData.is_banned : interactToolStatus.is_banned
    };
    const defaultOptions = {
      context: defaultContext,
      appId: watchInitData.interact.paas_app_id,
      accountId: watchInitData.join_info.third_party_user_id,
      channelId: groupInitData.channel_id,
      token: groupInitData.access_token,
      hide: false // 是否隐身
    };
    return defaultOptions;
  }
  // 设置主频道静默状态(v4)
  setMainChannelMute(mute) {
    if (mute) {
      // _removeListeners(this.msgInstance);
    } else {
      // _addListeners(this.msgInstance);
    }
  }

  // 子房间上线发送group信息
  // TODO:根据中台需要，看是否这个方法还放在 msgServer中
  sendGroupInfoAfterJoin(msgInstance) {
    const roomBaseServer = useRoomBaseServer();
    const groupServer = useGroupServer()
    const { watchInitData } = roomBaseServer.state;
    const { groupInitData } = groupServer.state

    msgInstance.emitRoomMsg({
      type: 'group_join_info',
      nickname: watchInitData.join_info.nickname,
      ...groupInitData,
      accountId: watchInitData.join_info.third_party_user_id
    });
  }

  /**
   * 销毁子房间聊天实例
   * @param {boolean} isQuitGroups 是否退出群组 false：不退出；true 退出
   * @returns
   */
  destroyGroupMsg(isQuitGroups = false) {
    if (!this.groupMsgInstance) return;
    this.groupMsgInstance.destroy(isQuitGroups);
    this.groupMsgInstance = null;
    this.changeChannel(this.msgInstance);
  }

  /**
   * 销毁主房间聊天实例
   * @param {boolean} isQuitGroups 是否退出群组 false：不退出；true 退出
   */
  destroy(isQuitGroups = false) {
    if (this.msgInstance) {
      this.msgInstance.destroy(isQuitGroups);
      this.msgInstance = null;
    };

    // this.changeChannel(this.groupMsgInstance);
  }

  // 退出tim群组
  quitTimGroups() {
    if (this.msgInstance?.msg) {
      this.msgInstance.msg.quitTimGroups?.();
    }
  }

  // 仅退出tim登录
  logoutTim() {
    return this.msgInstance?.msg?.logoutTim?.();
  }

  // tim销毁
  destroyTim(isQuitGroups = false) {
    return this.msgInstance?.msg?.destroyTim?.(isQuitGroups);
  }

  // 获取tim用户状态
  getTimUserStatus() {
    return this.msgInstance?.msg?.getTimUserStatus?.();
  }

  // 获取当前主房间初始化参数
  getCurrentMsgInitOptions() {
    return JSON.parse(JSON.stringify(this.state.msgSdkInitOptions));
  }

  // 获取当前子房间初始化参数
  getCurrentGroupMsgInitOptions() {
    return JSON.parse(JSON.stringify(this.state.groupMsgSdkInitOptions));
  }

  // 单视频嵌入页面，不会加载互动sdk，但是需要判断是否是手机端
  // 所以设备检测需要去除对互动 sdk 的依赖
  isMobileDevice() {
    return !!/Android|webOS|iPhone|iPad|iPod|BB10|BlackBerry|IEMobile|Opera Mini|Mobile|mobile/i.test(window.navigator.userAgent || "")
  }

  /**
   * TIM踢出事件
   * @param {*} type
   * multipleAccount Web端，同一账号，多页面登录被踢
     multipleDevice 同一账号，多端登录被踢
     userSigExpired 签名过期
     REST_API_Kick REST API kick接口踢出
   */
  _onTimKickedOut(type) {
    console.log('[tim] 触发 onTimKickedOut 事件');
    this.$emit('onTimKickedOut', type)
  }

  /**
   * TIM网络变化事件
   * @param {*} state
   * connected 已接入网络
   * connecting 连接中。很可能遇到网络抖动，SDK 在重试。接入侧可根据此状态提示“当前网络不稳定”或“连接中”
   * disconnected 未接入网络。接入侧可根据此状态提示“当前网络不可用”。SDK 仍会继续重试，若用户网络恢复，SDK 会自动同步消息
   */
  _onTimNetStateChange(state) {
    console.log('[tim] 触发 onTimNetStateChange 事件:', state);
    this.$emit('onTimNetStateChange', state)
  }
}
export default function useMsgServer() {
  return new MsgServer();
}
